/*
Sohel 11/17/2022 2700912712 Implemented Copy Functionality
Sohel 12/04/2022 2700912712 Fixed Validation Issue.
Saikrishna 12/08/2022 2698948956 Removed name fields.
sai krisha 30/12/2022 2701116417 add code description values
Raghu 02/28/2023 2701116417 added new class for text feilds
sohel 03/06/2023 2701116417 Added validation message for existing value
Akhila 06/07/2023 2701116417 added breadcrum code and description
Gireesh 12/11/2023 2701116417 Added Filter Name and Filter Description  validations
Gireesh 14/11/2023 2701116417 changed Filter code to id in get and save  api in filter rules
*/
import React, {useContext, useEffect} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from './../../../../../components/PageLoader/index';
import {fetchFilterAllCodeAndDisplayName} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {postCopyFilter} from '../../../../../redux/reducers/BRE/FilterRuleGroup';
// import {codeRegex} from '../../../../../util/RegexPatterns';
// import {codeValidationMessage} from '../../../../../util/Content';
// import {nameWithSpecialCharacter} from '../../../../../util/Content';
// import {nameRegexAllow} from '../../../../../util/RegexPatterns';
import BreadCrums from '../../../../../util/BreadCrum';
const CopyFilter = ({oldFilterCode, codeAndDescription}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const {iscopyLoading} = useSelector(({addFilterRuleGroup}) => addFilterRuleGroup);
  const {allFilterCodeAndDisplayName} = useSelector(({addRuleGroup}) => addRuleGroup);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const initialValues = {
    code: '',
    description: '',
    name: '',
  };
  const checkCodeExist = (value) => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allFilterCodeAndDisplayName.filter((i) => {
        if (
          i?.ruleGroupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkCodeAlreadyExist = (value) => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allFilterCodeAndDisplayName.filter((i) => {
        if (
          i?.ruleGroupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };

  const schema = Yup.object().shape({
    code:
    //  Yup.string()
    //   .required('Filter Code is required')
    //   .matches(codeRegex, codeValidationMessage)
    //   .test('code', 'Filter Code already exist', (value) => !checkCodeExist(value))
    //   .test(
    //     'code',
    //     'Filter Code has already been used in the past',
    //     (value) => !checkCodeAlreadyExist(value),
    //   ),
      Yup.string()
        .required('Filter Name is required')
        
        .test('code', 'Filter Name already exist', (value) => !checkCodeExist(value))
        .test(
          'code',
          'Filter Name has already been used in the past',
          (value) => !checkCodeAlreadyExist(value)
        ),
    //   name:Yup.string()
    //     .test("displayName", "Filter Name is required", (value) => {
    //      return value?.replaceAll(" ", "");
    // })
    // .required("Filter Name is required")
    // .test("displayName", "Filter Name already exist", (value) => !checkDisplayNameExist(value)),
    description: Yup.string()
      .test('description', 'Filter Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .required('Filter Description is required')
      .max(100, 'Filter Description cannot exceed 100 characters'),
     

  });

  const handleSubmit = (values) => {
    if (values) {
      const data = {
        code: values?.code ? values?.code : '',
        description: values?.description ? values?.description : '',
        displayName: values?.name ? values?.name : '',
        oldFilterRuleGroupcode: oldFilterCode,
        filterRuleGroupId:codeAndDescription?.groupId,
      };
      dispatch(postCopyFilter(data));
    }
  };

  useEffect(() => {
    dispatch(fetchFilterAllCodeAndDisplayName());
  }, []);
  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
          >
            {(props) => {
              const {
                values,
                handleSubmit,
                handleReset,
                handleChange,
                touched,
                errors,
                resetForm,
                handleBlur,
                setFieldValue,
              } = props;
              return (
                <div>
                  <BreadCrums
                    name={'Name'}
                    code={codeAndDescription?.code}
                    description={'Description'}
                    descriptionValue={codeAndDescription?.description}
                  />
                  <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="global-field-textfields new-standard-textfields">
                      <ErrorBoundaryForComponents>
                        <Grid container spacing={2}>
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Filter Name"
                              margin="dense"
                              name="code"
                              variant="outlined"
                              value={values?.code}
                              label="Filter Name"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              required
                              onBlur={handleBlur}
                              inputProps={{maxLength: 25}}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('code', e.target.value);
                              }}
                              touched={touched.code}
                              error={Boolean(errors.code && touched.code)}
                              fullWidth
                            />
                            <FormHelperText style={{color: 'red'}} variant="outlined">
                              {touched.code && errors.code}
                            </FormHelperText>
                          </Grid>
                          {/* <Grid item xs={6} className="form-group">
                            <TextField
                              className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Filter Name"
                              margin="dense"
                              name="Filter Name"
                              value={values.name}
                              variant="outlined"
                              label="Filter Name"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onBlur={handleBlur}
                              onChange={(e)=>{
                                handleChange(e)
                                setFieldValue("name",e.target.value)
                              }}
                              touched={touched.name}
                              required
                              error={Boolean(errors.name && touched.name)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.name && errors.name}
                            </FormHelperText>
                            </Grid> */}
                          <Grid item xs={6} className="form-group">
                            <TextField
                              // className={` ${classes.labelName} ${classes.inputLabel}`}
                              placeholder="Enter Filter Description"
                              margin="dense"
                              name="description"
                              value={values.description}
                              variant="outlined"
                              label="Filter Description"
                              // InputLabelProps={{
                              //   shrink: true,
                              // }}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                handleChange(e);
                                setFieldValue('description', e.target.value);
                              }}
                              touched={touched.description}
                              required
                              inputProps={{maxLength: 100}}
                              error={Boolean(errors.description && touched.description)}
                              fullWidth
                            />
                            <FormHelperText variant="outlined">
                              {touched.description && errors.description}
                            </FormHelperText>
                          </Grid>
                        </Grid>
                      </ErrorBoundaryForComponents>
                    </div>
                    <div className="button-spacing-mb new-standard-textfields">
                      <Button
                        variant="outlined"
                        onClick={() => {
                          resetForm(initialValues);
                        }}
                        className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn ml-1 ${classes.buttonRoot}`}
                      >
                        Copy
                      </Button>
                    </div>
                  </form>
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {iscopyLoading && <PageLoader />}
    </>
  );
};

export default CopyFilter;
